import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { FileOperationsController } from '@commoncore/controller/FileOperationsController';
import { JioPhoneCallController } from '@commoncore/controller/JioPhoneCallController';
import { ListViewController } from '@commoncore/controller/ListViewController';
import { PrivateFolderController } from '@commoncore/controller/PrivateFolderController';
import { TeamFoldersController } from '@commoncore/controller/TeamFoldersController';
import { IndexDBImplementation } from '@commoncore/implementation/IndexDBImplementation';
import { PreviewImplementation } from '@commoncore/implementation/PreviewImplementation';
import { SearchImpementation } from '@commoncore/implementation/SearchImplementation';
import { TeamFoldersImplementation } from '@commoncore/implementation/TeamFoldersImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { CUT_COPY_OPERATION } from '@commoncore/services/universal.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { AlbumsController } from '@mainrepo/app/core/controller/AlbumsController';
import { AllFilesController } from '@mainrepo/app/core/controller/AllFilesController';
import { AudiosController } from '@mainrepo/app/core/controller/AudiosController';
import { DigiLockerController } from '@mainrepo/app/core/controller/DigiLockerController';
import { DocumentsController } from '@mainrepo/app/core/controller/DocumentsController';
import { FavoritesController } from '@mainrepo/app/core/controller/FavoritesController';
import { HomeScreenController } from '@mainrepo/app/core/controller/HomeScreenController';
import { PeoplesTabController } from '@mainrepo/app/core/controller/PeoplesTabController';
import { PhotosController } from '@mainrepo/app/core/controller/PhotosController';
import { RecentFilesController } from '@mainrepo/app/core/controller/RecentFilesController';
import { SearchController } from '@mainrepo/app/core/controller/SearchController';
import { SharedFilesListController } from '@mainrepo/app/core/controller/SharedFilesListController';
import { TrashController } from '@mainrepo/app/core/controller/TrashController';
import { VideosController } from '@mainrepo/app/core/controller/VideosController';
import { moveCopyController } from '@mainrepo/app/core/controller/moveCopyController';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';
import { AlbumsImplementation } from '@mainrepo/app/core/implementation/AlbumsImplementation';


@Component({
  selector: 'app-file-operations-wrapper',
  templateUrl: './file-operations-wrapper.component.html',
  styleUrls: ['./file-operations-wrapper.component.scss'],
})
export class FileOperationsWrapperComponent implements OnInit {
  @Output() restoreItems = new EventEmitter();
  @Output() deleteForever = new EventEmitter();
  @Input() headingTitle:any="";
  controller: any;
  fileOpsImplementationRef: any;
  public universalService:any;
  currentTabController:any;
  listService: any;
  noOfCompletedFiles:number = 0;
  progressPercentage:number = 0;
  totalFiles:number = 0;
  showProgressBar:boolean = false;
  currentOperation:any;
  mcController: any;
  mcImplRef:any;
  public router:any;
  loggerService:any;
  tempnodes:any;
  allfilescontroller:any;
  itemsCopied: any;
  shareAccessService: any;
  trashController: any;
  localStorageSvc:LocalStorageSvc;
  cleverTapEventsService:any;
  sessionStorageService: any;
  impl: any;
  db: IndexedDBModule;
  // itemsCopied : object= {"objects": [], "unprocessed": []}

  isAppCreationCompUse:boolean = true
  searchImplementation:any
  cacheImpl:IndexDBImplementation;
  albumsImplementation: AlbumsImplementation;
  folderCreationOnCopy:any = '';
  teamFolderImplementation:any;

  constructor(public globalService:GlobalService,
    public changeDetectorRef : ChangeDetectorRef) {
    this.setEnvObjects(globalService)
   }

  ngOnInit(): void {
    this.controller = FileOperationsController.getInstance(this.globalService);
    this.mcController = moveCopyController.getInstance(this.globalService);
    this.trashController = TrashController.getInstance(this.globalService);
    this.fileOpsImplementationRef  = this.controller.fileOperationsImplementation
    this.controller.setEnvObjects(this.globalService);
    this.mcController.setEnvObjects(this.globalService);
    this.mcImplRef = this.mcController.moveCopyImplementation;
    this.fileOpsImplementationRef.setHandler(this.globalService)
    this.allfilescontroller=AllFilesController.getInstance(this.globalService);
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
    this.setIsAppCreationCompUse();
    this.searchImplementation = SearchImpementation.getInstance(this.globalService);
    this.albumsImplementation = AlbumsImplementation.getInstance(this.globalService);
    this.teamFolderImplementation = TeamFoldersImplementation.getInstance(this.globalService);
    this.db = IndexedDBModule.getInstance(this.globalService);
    this.subscibeDragAndDropEvents();
    this.subscibeFileOperationsEvents();
  }
  subscibeDragAndDropEvents(){
    var destinationObject;
    AppEvents.globalObservable.subscribe(response => {
      if(response["FileOpType"] == "move"){
        if(response["continueFileOperation"]){
          if(response["type"] == "Move"){
            this.universalService.selectedNodes = destinationObject["files"];
            this.confirmOperation(destinationObject);
          }
          return
        }
        this.universalService.selectedFolder = response["destinationFolder"]
        if(response["destinationFolder"]["shareType"] == 'R' && response["destinationFolder"]["isShared"]){
          destinationObject = response["object"];
          AppEvents.optionSelected.next({"showChangeAccessConfirmation":true,"buttonName":"Move","noOfFiles":this.universalService.selectedNodes.length});
          return;
        }
        this.confirmOperation(response["object"])
      }
    });
  }

  subscibeFileOperationsEvents(){
    AppEvents.globalObservable.subscribe(event => { 
      switch(event["type"]){
        case "confirmOperation":
          this.confirmOperation(event["data"]);
          break;
        case "createNewFolder":
          this.createNewFolder();
          break;
        case "confirmShareOperation":
          this.confirmShareOperation(event["data"])
          break;
        case "confirmFileOpn":
          this.confirmFileOpn(event["data"]);
          break;
        case "createNewAlbum":
          this.createNewAlbum();
          break;
        case "closeCreateModal":
          this.closeCreateModal();
          break;
        case "goBackToPreviousScreen":
          this.goBackToPreviousScreen();
          break;
        case "validateBeforeCreatingAlbum":
          this.validateBeforeCreatingAlbum(event["data"]);
          break;
        case "close":
          this.close();
          break;
        case "removeFolderKeys":
          this.removeFolderKeys();
          break;
        case "fetchNestedFoldersData":
          this.fetchNestedFoldersData(event["data"]);
          break;
        case "fetchNestedFoldersDataForMobile":
          this.fetchNestedFoldersDataForMobile(event["data"]);
          break;
        case "fetchNestedFolderDataForShared":
          this.fetchNestedFolderDataForShared(event["data"]);
          break;
        case "fetchNestedFolderDataForTeamFolder":
          this.fetchNestedFolderDataForTeamFolder(event["data"]);
          break;
        case "fetchNestedFolderDataForTeamFolderMobile":
          this.fetchNestedFolderDataForTeamFolderMobile(event["data"]);
          break;
        case "fetchNestedFolderDataForMobileShared":
          this.fetchNestedFolderDataForMobileShared(event["data"]);
          break;
        case "validateBeforeCreatingFolder":
          this.validateBeforeCreatingFolder(event["data"]);
          break;
        case "createFolderAndMove":
          this.createFolderAndMove();
          break;
        case "createFolderAndCopy":
          this.createFolderAndCopy();
          break;
        default:
          console.log("no event found",event)
      }
    });
  }

  setIsAppCreationCompUse(){
    var classRef=this
    this.isAppCreationCompUse= true;
    if(this.router.url.includes('/contact') ||  this.universalService.isMobileDevice)
      this.isAppCreationCompUse= false;
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.router = globalService.getRouterRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.shareAccessService = globalService.getShareAccessServiceRef();
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    this.cleverTapEventsService = globalService.getCleverTapEventsvc();
    this.sessionStorageService = globalService.getSessionStorageSvcRef(); 
    this.impl = PreviewImplementation.getInstance(globalService);
    this.cacheImpl = IndexDBImplementation.getInstance(globalService);

  }

  

  createNewFolder(){
    this.fileOpsImplementationRef.resetValuesBeforeCreatingFolder();
    AppEvents.globalObservable.next({createFolder: true});
  }


  removeFolderKeys(){
    this.controller.removeFolderKeys();
  }

  fetchNestedFoldersData(event){
    if(this.universalService.currentTab == "PrivateFolder"){
      this.controller.fetchNestedPrivateFoldersData(event);
      this.changeDetectorRef.detectChanges();
    }else{
      this.controller.fetchNestedFoldersData(event);
      this.changeDetectorRef.detectChanges();
    }
   
  }

  fetchNestedFoldersDataForMobile(event){
    if(this.universalService.currentTab == "PrivateFolder"){
      this.controller.fetchNestedPrivateFoldersDataForMobile(event);
      this.changeDetectorRef.detectChanges();
    }else{
      this.controller.fetchNestedFoldersDataForMobile(event);
      this.changeDetectorRef.detectChanges();
    }
  }

  fetchNestedFolderDataForShared(event){
    this.controller.fetchNestedFoldersDataForShared(event);
  }

  fetchNestedFolderDataForTeamFolder(event){
    this.controller.fetchNestedFoldersDataForTeamFolder(event);
  }

  fetchNestedFolderDataForTeamFolderMobile(event){
    this.controller.fetchNestedFoldersDataForTeamFolderMobile(event);
  }

  fetchNestedFolderDataForMobileShared(event){
    this.controller.fetchNestedFoldersDataForMobileShared(event);
  }

  validateBeforeCreatingFolder(value){
    this.fileOpsImplementationRef.validateBeforeCreatingFolder(value);
  }
 
  close() {

    this.fileOpsImplementationRef.close();
  }


  createNewAlbum(){
    this.fileOpsImplementationRef.resetValuesBeforeCreatingAlbum();
  }


  closeCreateModal(){
    this.fileOpsImplementationRef.closeCreateModal();
  }

  goBackToPreviousScreen(){
    this.fileOpsImplementationRef.goBackToPreviousScreen();
    

  }

  validateBeforeCreatingAlbum(value){
    this.fileOpsImplementationRef.validateBeforeCreatingAlbum(value);
    
  }
 
  restoreFiles(){
    // this.loggerService.log("inside file ops wrapper restore")
    // this.restoreItems.emit()
    this.loggerService.log("called restore function from trash controller");
    this.trashController.restoreFiles()
  }

  deleteParmanent(){
    // this.loggerService.log("inside file ops wrapper delete param")
    // this.deleteForever.emit()
    this.loggerService.log("inside file ops wrapper delete param")
    this.trashController.deleteForever();
  }

  confirmShareOperation(object){
    this.itemsCopied = {};
    this.loggerService.log("confirming the operation",object);
    this.currentOperation = "SHAREPERMISSION";
    try {
      this.universalService.showLoader = true;
      this.actionCompletedSuccessfully(this.currentOperation);
    } catch(exc){
      this.loggerService.log("exception for operation",exc)
    }
  }

  confirmOperation(object){
    this.universalService.dragDropWithinApp = false;
    this.universalService.destinationFolder = {"objectName":"JioAICloud"}
    this.itemsCopied = {};
    this.loggerService.log("confirming the operation",object);
    this.currentOperation = object["operation"]
    try {
      this.noOfCompletedFiles = 0;
      this.totalFiles = object["files"].length;
      if(object["files"].length>30 && this.universalService.popUpToBeOpened != ""){  // it means that if the operation will be performed in batches only if it is move,copy,delete and will perform as a single operation if it is add/remove fav
        this.progressPercentage = 0;
        this.showProgressBar = true;
        
        this.universalService.popUpToBeOpened = "";
        AppEvents.optionSelected.next({closeAll:true});
        AppEvents.globalObservable.next({closeAll:true});
        this.universalService.showLoader = false;
        this.tempnodes = Object.assign([], this.universalService.selectedNodes);
        this.performSelectedOperationInBatches(object);
      } else{
        this.universalService.showLoader = true;
        this.performSelectedOperationAngUpdateUI(object);
    }  
    } catch(exc){
      this.loggerService.log("exception for operation",exc)
    }
  }

  confirmMoveOperation(){
    const rootFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
    this.universalService.selectedNodes.map(obj=>{
      if(obj["FullObject"]){
        obj["FullObject"]["parentObjectKey"] = this.universalService.selectedFolder  ? this.universalService.selectedFolder["objectKey"]: rootFolderKey;
      }else{
        obj["parentObjectKey"] = this.universalService.selectedFolder ? this.universalService.selectedFolder["objectKey"] : rootFolderKey;
      }
    })
    var object={
      "files":this.universalService.selectedNodes,
      "operation":"MOVE",
      "correlationId": USER_DETAILS["USER_DETAILS"]["rootFolderKey"]
    }
    this.confirmOperation(object);
  }
  async createFolderAndMove(){
    try {
      await this.controller.createFolder(this.fileOpsImplementationRef.folderName);
       //   await this.cacheImpl.addFolderIndexDB([this.universalService.createFolderApiResponse]) 
      await this.confirmMoveOperation();
    } catch (exc) {
      this.loggerService.log("exception for creating and moving to folder", exc);
    }
  }

  // async createFolderAndMove(){
  //   try {
  //     await this.controller.createFolder(this.implRef.folderName);
  //     await this.confirmMoveOperation();
  //   } catch (exc) {
  //     this.loggerService.log("exception for creating and moving to folder", exc);
  //   }
  // }

  confirmCopyOperation(){
    var object={
      "files":this.universalService.objectsToBeAdded,
      "operation":"COPY",
      "correlationId": USER_DETAILS["USER_DETAILS"]["rootFolderKey"]
    }
    this.confirmOperation(object);
  }

  // async createFolderAndCopy(){
  //   try{
  //     await this.controller.createFolder(this.fileOpsImplementationRef.folderName);
  //     await this.confirmCopyOperation();
  //   }catch(exc){
  //     this.loggerService.log("exception for creating and copying to folder", exc);
  //   }
  // }
  
  async createFolderAndCopy(){
      try{
        this.universalService.showLoader = true;
        if(this.mcImplRef.currentTab == "sharedwithme"){
          await this.controller.createFolderInsideSharedWithMeFolder(this.fileOpsImplementationRef.folderName,this.fileOpsImplementationRef.folderNames[this.fileOpsImplementationRef.folderNames.length - 1])
          await this.mcController.copyToSelectedFolder(this.universalService.selectedNodes);
        }else if(this.mcImplRef.currentTab == "teamfoldercopy"){          
          var result = await this.controller.createFolderInsideTeamFolder(this.fileOpsImplementationRef.folderName,this.fileOpsImplementationRef.folderNames[this.fileOpsImplementationRef.folderNames.length - 1])
          await this.confirmCopyOperation();
        }else{
          await this.controller.createFolder(this.fileOpsImplementationRef.folderName);
          this.folderCreationOnCopy = this.universalService.createFolderApiResponse
            //await this.cacheImpl.addFolderIndexDB([this.universalService.createFolderApiResponse]) 
          await this.confirmCopyOperation();
        }
        this.cleverTapEventsService.onShareCreateCopyHereClick(this.universalService.currentTab);
        this.fileOpsImplementationRef.folderName = "";
      }catch(exc){
        this.loggerService.log("exception for creating and copying to folder", exc);
      }
     
    }

  async performSelectedOperationAngUpdateUI(object){
    var result;
    try { 
      if(object["operation"] == "BRN" || object["operation"] == "BDU" || object["operation"] == "FRN" || object["operation"] == "FTR" || this.universalService.currentAlbum != undefined){
        result = await this.controller.performSelectedOperation(object["files"],object["operation"],object["correlationId"]);
        if(result["status"] == "success"){ 
          if(object["operation"] == "BRN" || object["operation"] == "BDU"){
            this.universalService.currentAlbum.boardName = object["files"].boardName;
            this.universalService.currentAlbum.boardDescription = object["files"].boardDescription;
            this.universalService.currentAlbum.lastModifiedDate = new Date().getTime();
            //Disabled cache for Album - cause of issue when users joins/leaves boards, updated data was not available 
            //this.updateAlbumDataInDB(this.fileOpsImplementationRef.myAlbumsDBStoreName, this.universalService.currentAlbum);
          }
          if(this.universalService.currentAlbum != undefined && (object["operation"] == "FRN" || object["operation"] == "SETFAV" || object["operation"] == "UNSETFAV")){
            this.universalService.currentAlbum.lastModifiedDate = new Date().getTime();
            //Disabled cache for Album - cause of issue when users joins/leaves boards, updated data was not available 
            //this.updateAlbumDataInDB(this.fileOpsImplementationRef.myAlbumsDBStoreName, this.universalService.currentAlbum);
          }
          if(result != null){
            this.noOfCompletedFiles = this.noOfCompletedFiles + object["files"].length;
            this.progressPercentage = (this.noOfCompletedFiles/this.totalFiles) * 100;
            this.showProgressBar = false;
            setTimeout(() => {
              this.universalService.showLoader = false;
            }, 1000);
          }
          if(object["operation"] != "BRN" && object["operation"] != "BDU" && !this.universalService.showFileInfo){
            AppEvents.optionSelected.next({closeAll:true});
            AppEvents.globalObservable.next({closeAll:true});
          }
          await this.actionCompletedSuccessfullyForAlbums(result["executed operation"]);
        }
        return;
      } else 
      if(this.currentOperation == "COPY" && this.universalService.errorMessage == ''){
        if(this.universalService.isMobileDevice && this.universalService.showMobOptionMenu){
          this.universalService.showMobOptionMenu = false
        }
        result = await this.mcController.copyToSelectedFolder(object["files"]);
        if(result){
          result["operation"]= "COPY";
          this.updateCopiedItems(result);
          result["totalFilesCopied"] = this.totalFiles;
          await this.fileOpsImplementationRef.addToRepo(result,"","",this.totalFiles);
          const currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true);
          const rootFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
          var currentlyOpenedFolder = currentFolderKey ? currentFolderKey : rootFolderKey;
          var destinationFolderKey = this.universalService.selectedFolder ? (this.universalService.selectedFolder["FullObject"]?this.universalService.selectedFolder["FullObject"]["objectKey"]:this.universalService.selectedFolder["objectKey"]) : rootFolderKey;
          if(this.universalService.currentTab == 'allfiles' && !this.universalService.fetchAllRecentFiles
          && ( currentlyOpenedFolder == destinationFolderKey || (this.folderCreationOnCopy!='' && this.folderCreationOnCopy.parentObjectKey == currentlyOpenedFolder) )){
            this.allfilescontroller.getAllFilesAndFolders()
          }
          AppEvents.emit(EventsList.UPDATE_RECENT);
          if(this.router.url.includes('/teamfolders')){
            var tfController = TeamFoldersController.getInstance(this.globalService);
            tfController.setEnvObjects(this.globalService)
            let tfObjectKey = this.sessionStorageService.getNestedTeamFolderkey();
             //If copy happen in the same folder as user is in, then only allow to get latest, not in all cases, avoiding api call
            if(destinationFolderKey == currentFolderKey) {
              tfController.getCurrentTeamFolderContent(tfObjectKey, false);
            }
            
          }
          this.folderCreationOnCopy='';
        }
        this.fileOpsImplementationRef.folderKeys = [USER_DETAILS["USER_DETAILS"]["rootFolderKey"]];
      } else if(this.currentOperation == "COPY" && !result){
        this.universalService.showLoader = false;
        return;
      } else{
        
        result = await this.controller.performSelectedOperation(object["files"],object["operation"],object["correlationId"],object["opType"]);
  
        if(result["status"] == "success"){ 
          var filesListOnWhichOperationWasPerformed = this.universalService.selectedNodes;
          if(this.universalService.isPreviewOpenFromSearchDropdown){
            if(this.universalService.listView && !this.universalService.isMobileDevice){
              var file = this.universalService.selectedNodes[0];
              var found =this.universalService.allNodesDataFromListView.find(node=>node["data"]["objectId"] == file["objectKey"])
              if(found){
                var listController = ListViewController.getInstance(this.globalService);
                listController.addToIndexArray(found["rowIndex"]); 
              }
            }
            await this.actionCompletedSuccessfullyForSearch(result["executed operation"])
          }
          // else{
            this.universalService.selectedNodes = filesListOnWhichOperationWasPerformed;
            await this.actionCompletedSuccessfully(result["executed operation"]);

          // }
        } else if(result["status"] == "moved successfully"){
          this.fileOpsImplementationRef.folderKeys = [USER_DETAILS["USER_DETAILS"]["rootFolderKey"]];
          this.listService.noFoldersPresent = false;
          if(this.universalService.onMoveFolderCreationSameFolder || this.universalService.cutOrCopyOperationType == CUT_COPY_OPERATION.MOVE){
           await this.allfilescontroller.getAllFilesAndFolders()
          } 
          let folderName =  this.universalService.selectedFolder  ? this.universalService.selectedFolder["objectName"]: "JioAICloud";
          if(folderName === undefined) {// While Moving objects with keyboard shortcut, selectedFolder is not available 
            var allFolderNames = this.globalService.getFolderServiceRef().breadCrumbsList;
            folderName = allFolderNames[allFolderNames.length-1].objectName;
          }
          if(this.universalService.isPreviewOpenFromSearchDropdown){
            await this.actionCompletedSuccessfullyForSearch(result["executed operation"])
          }else{
            AppEvents.optionSelected.next({closeAll:true});
            AppEvents.globalObservable.next({closeAll:true});
            await this.actionCompletedSuccessfully(result["executed operation"]);

          }
          if(this.universalService.currentTab == 'allfiles' && this.universalService.fetchAllRecentFiles){
            AppEvents.emit(EventsList.UPDATE_RECENT);
          }
          var str = this.totalFiles > 1 ? ' items ' : ' item '
          if(result["containsIcloudFolder"] == true){
            this.universalService.showToast(TOAST["SYSTEM_FOLDER_RESTRICTED_OPERATIONS"] + 'moved', 'success');
          }else{
            this.universalService.showToast(this.totalFiles + str + "moved successfully to '"+folderName + "'" , "success");
          }
          //this.universalService.showViewButton = true disabled view button for move operation 512718 fix 
          AppEvents.optionSelected.next({movecopy:false});
          AppEvents.optionSelected.next({rename:false});
        } else if(result == null || result == undefined) {
          this.universalService.showToast(TOAST["GENERIC_ERROR"],"error");
          this.universalService.showLoader = false;
        }
      }
      if(result != null){
        this.noOfCompletedFiles = this.noOfCompletedFiles + object["files"].length;
        this.progressPercentage = (this.noOfCompletedFiles/this.totalFiles) * 100;
        this.showProgressBar = false;
        setTimeout(() => {
          this.universalService.showLoader = false;
        }, 1000);
        if(this.currentOperation == "TRASH"){
          if(result["containsIcloudFolder"] == true){
            this.universalService.showToast( TOAST["SYSTEM_FOLDER_RESTRICTED_OPERATIONS"] + 'deleted', 'success');
          }else{
            const deleteSuccessfulMsg =  this.noOfCompletedFiles+(this.noOfCompletedFiles > 1? ' item(s)' : ' item' )+ ' deleted successfully';  
            this.universalService.showToast(deleteSuccessfulMsg, 'success');
          }
          
            jQuery("[class*='modal-backdrop']").remove();
        }
      }
    }catch(exc){
      console.log("exception in file operation", exc)
      this.universalService.showToast(TOAST["GENERIC_ERROR"],"error");
      this.universalService.showLoader = false;
    }
  }


  async performSelectedOperationInBatches(object){
    
    try {  
      if(object["files"].length>30){
          var array = [];
          var result;
          array = object["files"].splice(0,30);
          if(this.currentOperation == "COPY"){ // if copy operation is being performed
            result =await this.mcController.copyToSelectedFolder(array);
            if(result){
              this.updateCopiedItems(result);
            }else{
              this.showProgressBar = false;
            }
          } else{ // if operation other than COPY is being performed
            result = await this.controller.performSelectedOperation(array,object["operation"],object["correlationId"],object["opType"]);
          }
          if(result != null){
            this.noOfCompletedFiles = this.noOfCompletedFiles + array.length
            this.progressPercentage = (this.noOfCompletedFiles/this.totalFiles) * 100;
            this.performSelectedOperationInBatches(object);
          }
        } else {
          this.universalService.selectedNodes = this.tempnodes;
          await this.performSelectedOperationAngUpdateUI(object)
      }
    } catch(exc){
      this.loggerService.log("exception in performing operation in batches")
    }

  }

  async actionCompletedSuccessfully(executedOperation){
    var self = this;
    this.universalService.showLoader = true;
    this.universalService.showMobOptionMenu = false;
    switch(this.universalService.currentTab){
      case 'allfiles':
      if(this.universalService.fetchAllRecentFiles){ 
        if(this.universalService.listView && !this.universalService.isMobileDevice){
          this.currentTabController = ListViewController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          if(executedOperation == 'TRASH')
           this.universalService.currentViewDataSize = this.universalService.currentViewDataSize - this.universalService.selectedNodes.length
          this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        } else{
          this.currentTabController = RecentFilesController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          if(executedOperation == 'TRASH')
            this.universalService.currentViewDataSize = this.universalService.currentViewDataSize - this.universalService.selectedNodes.length
          this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }

        if(executedOperation == 'TRASH' && this.universalService.currentViewDataSize < 1){ 

          this.currentTabController = RecentFilesController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          this.currentTabController.fetchNextPageData()
        }

      }else{
        var updatedData;
        if(executedOperation == "COPY" || executedOperation == "MOVE" || executedOperation == "RENAME" || executedOperation == "TRASH"){
          AppEvents.emit(EventsList.UPDATE_RECENT);
        } else if(executedOperation == "SETFAV" || executedOperation == "UNSETFAV") {
          AppEvents.emit(EventsList.UPDATE_RECENT, executedOperation);
        }
        let find=this.universalService.selectedNodes.find(file=> file["objectType"] == "FE")
        if(this.universalService.listView && !this.universalService.isMobileDevice){
          this.currentTabController = ListViewController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
           updatedData = await this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }else{
          this.currentTabController = AllFilesController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService);
             updatedData = await  this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }
        if(executedOperation == 'TRASH' || executedOperation == 'MOVE' || executedOperation == 'MOVETOPF'){ 

          this.currentTabController = AllFilesController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          if(updatedData == "empty") this.currentTabController.getNextPageData()
        }
        
      }
      break;
      case "Home":
        var updatedData;
        if(executedOperation == "COPY" || executedOperation == "MOVE" || executedOperation == "RENAME" || executedOperation == "TRASH"){
          AppEvents.emit(EventsList.UPDATE_RECENT);
          AppEvents.emit(EventsList.RECENT_UPLOAD_UPDATE);
        } else if(executedOperation == "SETFAV" || executedOperation == "UNSETFAV") {
          AppEvents.emit(EventsList.UPDATE_RECENT, executedOperation);
        }
        this.currentTabController = HomeScreenController.getInstance(this.globalService);
        this.currentTabController.setEnvObjects(this.globalService);
        updatedData = await  this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        // if(executedOperation == 'TRASH' || executedOperation == 'MOVE' || executedOperation == 'MOVETOPF'){ 
        //   this.currentTabController = AllFilesController.getInstance(this.globalService);
        //   this.currentTabController.setEnvObjects(this.globalService)
        //   if(updatedData == "empty") this.currentTabController.getNextPageData()
        // }
      break;
      case "photos":
        this.currentTabController = PhotosController.getInstance(this.globalService);
        this.currentTabController.setEnvObjects(this.globalService)
        this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        break;
      case "audio":
        var updatedData;
        if(this.universalService.listView && !this.universalService.isMobileDevice){
          this.currentTabController = ListViewController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          // if(executedOperation == "MOVE" && this.universalService.selectedFolder.objectName == 'Private Folder')
          //   executedOperation = "MOVETOPF"
            updatedData = await this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        } else{
          this.currentTabController = AudiosController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          updatedData = await this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }
        if(executedOperation == 'TRASH' || executedOperation == 'MOVE'){
          this.currentTabController = AudiosController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          if(updatedData == "empty")
            this.currentTabController.fetchNextPageData()
        }
        break;
      case "videos":
        this.currentTabController = VideosController.getInstance(this.globalService);
        this.currentTabController.setEnvObjects(this.globalService)
        this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        break;
      case "docs":
        var updatedData;
        if(this.universalService.listView && !this.universalService.isMobileDevice){
          this.currentTabController = ListViewController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          // if(executedOperation == "MOVE" && this.universalService.selectedFolder.objectName == 'Private Folder')
          //   executedOperation = "MOVETOPF"
        
            updatedData = await this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
          
        }else{
          this.currentTabController = DocumentsController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          updatedData = await this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }
        if(executedOperation == 'TRASH' || executedOperation == 'MOVE'){
          this.currentTabController = DocumentsController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          if(updatedData == "empty")
            this.currentTabController.fetchNextPageData()
        }
        break;
      case 'Favorites':
        if(this.universalService.listView && !this.universalService.isMobileDevice){
          this.currentTabController = ListViewController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }else{
          this.currentTabController = FavoritesController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService);
          this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }
        break;

      case "Trash":
        if(this.universalService.listView && !this.universalService.isMobileDevice){
          this.currentTabController = ListViewController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        } else{
          this.currentTabController = TrashController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService);
          this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }
        break;
      case "sharedFiles":
        if(this.universalService.listView && !this.universalService.isMobileDevice){
          this.currentTabController = ListViewController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }else{
          this.currentTabController = SharedFilesListController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }
        if(executedOperation == 'TRASH' ){
          this.currentTabController = SharedFilesListController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          this.currentTabController.getNextPageData()
          if(this.universalService.showPreview  && executedOperation=='TRASH' && this.shareAccessService.singleObjectShared != "" && this.universalService.userLoggedIn == true){
            this.shareAccessService.singleObjectShared = "";
            this.sessionStorageService.setSingleSharedObject(this.shareAccessService.singleObjectShared,true)
            this.impl.closePreview();
            return;
          }
        }
        break;
        case "Person Details":
          this.currentTabController = PeoplesTabController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
          break;
          case "Place Details":
            this.currentTabController = PeoplesTabController.getInstance(this.globalService);
            this.currentTabController.setEnvObjects(this.globalService)
            this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
            break;
      case "teamfolders":
        if(this.universalService.listView && !this.universalService.isMobileDevice){
          this.currentTabController = ListViewController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }else{
          this.currentTabController = TeamFoldersController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService);
          this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }
        break;
      case "PrivateFolder":
        if(this.universalService.listView && !this.universalService.isMobileDevice){
          this.currentTabController = ListViewController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          var updatedData = await this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }else{
          this.currentTabController = PrivateFolderController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService);
          var updatedData =  await this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }
        if(executedOperation == 'TRASH' || executedOperation == 'MOVE' ){ 

          this.currentTabController = AllFilesController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          if(updatedData == "empty") {
            this.currentTabController.getNextPageData()
          }
        }
        break;
        case 'Search Results':
          var updatedData;
          if(this.universalService.listView && !this.universalService.isMobileDevice){
            this.currentTabController = ListViewController.getInstance(this.globalService);
            this.currentTabController.setEnvObjects(this.globalService)
            updatedData = await this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
          }else{
            this.currentTabController = SearchController.getInstance(this.globalService);
            this.currentTabController.setEnvObjects(this.globalService);
            updatedData = await  this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
          }
          if(executedOperation == 'TRASH' || executedOperation == 'MOVE' || executedOperation == 'MOVETOPF'){ 
  
            this.currentTabController = SearchController.getInstance(this.globalService);
            this.currentTabController.setEnvObjects(this.globalService)
            if(updatedData == "empty") this.currentTabController.getNextPageData()
          }
          break;
        case "DigiLocker":          
          this.currentTabController = DigiLockerController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService);
          this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
          break;
        case "JioPhoneCallAI":          
          this.currentTabController = JioPhoneCallController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService);
          updatedData = await this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
          if(updatedData == "empty") this.currentTabController.getNextPageData()
        break;
    }
  }

  async actionCompletedSuccessfullyForAlbums(executedOperation){
    AppEvents.optionSelected.next({rename:false}); 
    this.universalService.showLoader = true;
    this.universalService.showMobOptionMenu = false;
    if(this.universalService.selectedTab == "Album Details"){
      this.currentTabController = AlbumsController.getInstance(this.globalService);
      this.currentTabController.setEnvObjects(this.globalService);
      await this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
    }else if (this.universalService.selectedTab == "Favorites"){
      this.actionCompletedSuccessfully(executedOperation);
    }
  }

  async actionCompletedSuccessfullyForSearch(executedOperation){
    
    this.universalService.showLoader = true;
    this.universalService.showMobOptionMenu = false;
    switch(this.universalService.currentTab){
      case 'allfiles':
        this.searchImplementation.updateSummaryCountsAndUIForSearch(executedOperation)
        break;
      case "photos":
        this.currentTabController = PhotosController.getInstance(this.globalService);
        this.currentTabController.setEnvObjects(this.globalService)
        //this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        this.searchImplementation.updateSummaryCountsAndUIForSearch(executedOperation)
        break;
      case 'teamfolders':
        this.currentTabController = TeamFoldersController.getInstance(this.globalService);
        this.currentTabController.setEnvObjects(this.globalService)
        this.searchImplementation.updateSummaryCountsAndUIForSearch(executedOperation)
        break;
      case "audio":
        if(this.universalService.listView && !this.universalService.isMobileDevice){
          
          this.searchImplementation.updateSummaryCountsAndUIForSearch(executedOperation)
        } else{
          this.currentTabController = AudiosController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
         // await this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
         this.searchImplementation.updateSummaryCountsAndUIForSearch(executedOperation)
        }
        break;
      case "videos":
        this.currentTabController = VideosController.getInstance(this.globalService);
        this.currentTabController.setEnvObjects(this.globalService)
       // this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
       this.searchImplementation.updateSummaryCountsAndUIForSearch(executedOperation)
        break;
      case "docs":
        
        if(this.universalService.listView && !this.universalService.isMobileDevice){
        
          this.searchImplementation.updateSummaryCountsAndUIForSearch(executedOperation)
        }else{
          this.currentTabController = DocumentsController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
         // await this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
         this.searchImplementation.updateSummaryCountsAndUIForSearch(executedOperation)
        }
        break;
      case 'Favorites':
        if(this.universalService.listView && !this.universalService.isMobileDevice){
          this.currentTabController = ListViewController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService)
          this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
        }else{
          this.currentTabController = FavoritesController.getInstance(this.globalService);
          this.currentTabController.setEnvObjects(this.globalService);
        //  this.currentTabController.updateUIAfterPerformingAction(this.universalService.selectedNodes,executedOperation);
          this.searchImplementation.updateSummaryCountsAndUIForSearch(executedOperation)
        }
        break;

    }
  }

  updateCopiedItems(response){

  
    if(response && (!this.itemsCopied || Object.keys(this.itemsCopied).length === 0)){
      this.itemsCopied = response;
    } else if(response && this.itemsCopied){
      this.itemsCopied["objects"] = response["objects"] && response["objects"].length>0 ? 
          ([...this.itemsCopied["objects"], ...response["objects"] ]) : (this.itemsCopied["objects"] ? this.itemsCopied["objects"] : []);
      this.itemsCopied["unprocessed"] = response["unprocessed"] && response["unprocessed"].length>0 ? 
       ([...this.itemsCopied["unprocessed"], ...response["unprocessed"] ]) : (this.itemsCopied["unprocessed"]!=undefined ? this.itemsCopied["unprocessed"] : []);
    }

    response["objects"] = this.itemsCopied["objects"] ?this.itemsCopied["objects"]: 0 ;
    response["unprocessed"] = this.itemsCopied["unprocessed"] ? this.itemsCopied["unprocessed"] : 0;

  }

  updateAlbumDataInDB(dbStore, albumObj) {
    if(this.albumsImplementation.isMyAlbumDataInDB || this.albumsImplementation.isSharedAlbumDataInDB) {
      return this.db.update(dbStore, albumObj).then((result) => {
       
      });
    }
  }

  confirmFileOpn(object){
    if(object["confirm"]){
      AppEvents.globalObservable.next({"continueFileOperation":true,"type":object["type"],"FileOpType" : "move"});
    }
    AppEvents.optionSelected.next({"showChangeAccessConfirmation":false,"buttonName":"Move"});
  }
  
}
